module.exports = __webpack_public_path__ + "images/Premium_Black_Vertical.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/Premium_Black_Vertical.svg
// module id = 116
// module chunks = 0